import GlobalStyles from '@mui/material/GlobalStyles';
import type { TableRowType } from 'components/editor/grid/reduxStore/table.types';
import { getCellBackgroundColorStyles } from 'muiTheme/cellBackgroundColor';
import { useId, useMemo } from 'react';

// Emits the table's cell background colours as memoized global styles scoped to a per-table class, so the rules are
// only re-serialized when the rows change rather than on every render of the table.
export function useCellBackgroundColorStyles(rows: Pick<TableRowType, 'id' | 'cellConfig'>[] | undefined) {
  const id = useId();
  const cellBackgroundColorClassName = `py-cell-colours-${id.replace(/[^a-zA-Z0-9-]/g, '')}`;

  const cellBackgroundColorStyles = useMemo(() => {
    const styles = getCellBackgroundColorStyles(rows ?? [], `.${cellBackgroundColorClassName}`);
    return Object.keys(styles).length > 0 ? <GlobalStyles styles={styles} /> : null;
  }, [rows, cellBackgroundColorClassName]);

  return { cellBackgroundColorClassName, cellBackgroundColorStyles };
}
